import { cn, tv, VariantProps } from "@utils/tw"
import { createAppender, useBlockContext } from "eddev/blocks"
import { ComponentProps, HTMLProps } from "react"

type MessageProps = ComponentProps<"div"> & VariantProps<typeof adminMessageVariants>

export function AdminMessage(props: MessageProps) {
  return <div {...props} className={cn(adminMessageVariants(props), props.className)} />
}

const adminMessageVariants = tv({
  base: "admin-message-box",
})

export const SimpleAppender = createAppender((props) => {
  return (
    <button
      className="simple-appender components-button block-editor-inserter__toggle !inline-flex has-icon"
      onClick={() => props.onToggle()}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M11 12.5V17.5H12.5V12.5H17.5V11H12.5V6H11V11H6V12.5H11Z"></path>
      </svg>
    </button>
  )
})
